import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">
              NS 24 Design & Constructions
            </h3>
            <p className="text-gray-300">
              Building excellence through innovation and dedication.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-300 hover:text-white">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white">
                  Services
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-300 hover:text-white">
                  About
                </a>
              </li>
              <li>
                <a href="#projects" className="text-gray-300 hover:text-white">
                  Projects
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">Construction</li>
              <li className="text-gray-300">Design</li>
              <li className="text-gray-300">Renovation</li>
              <li className="text-gray-300">Consultation</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                <span className="text-gray-300">+91 7028882666</span>
              </div>
              <div className="flex items-center">
                <Mail className="w-5 h-5 mr-2" />
                <span className="text-gray-300">nitinshrrm439@gmail.com</span>
              </div>
              <div className="flex items-center mt-6">
                <div className="w-6 h-6 my-2 mr-2">
                  <MapPin className="w-full h-full" />
                </div>
                <span className="text-gray-300">
                  101, Laxamn Heights, Pimple Nilakh, Pune
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 mt-12 pt-8 text-center">
          <p className="text-gray-300">
            &copy; {new Date().getFullYear()} NS 24. All rights reserved.
          </p>
          <p className="text-gray-300">
            Developed & Maintained By
          </p>
          <p className="text-blue"><a href="https://nexolvetechnologiesindia.com">Nexolve Technologies</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;